import api from '../BaseUrl';

export type UploadKind = 'image' | 'resume';

/** Uploads a photo / screenshot (image) or the resume PDF and returns the stored file name. */
export const uploadFile = async (file: File, kind: UploadKind): Promise<string> => {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post<{ fileName: string }>(`/api/Admin/UploadFile?kind=${kind}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.fileName;
};
